"use strict";

import React from "react";
import Wprr from "wprr";
import Dbm from "dbm";

import ElfsightAggregatedRating from "../content/reviews/ElfsightAggregatedRating";

export default class StartPageHero extends Wprr.BaseObject {
	
	/**
	 * Constructor
	 */
	_construct() {
		
		super._construct();
	}
	
	
	_renderMainElement() {
		
		let title = this.getFirstInput("title", Wprr.sourceReference("blockData", "title"));
		let text = this.getFirstInput("text", Wprr.sourceReference("blockData", "text"));
		let image = this.getFirstInput(Wprr.sourceReference("blockData", "image.url"));
		let mobileImageUrl = this.getFirstInput(Wprr.sourceReference("blockData", "mobileImage.url"), Wprr.sourceReference("blockData", "image.url"));

		let mobileLayout = <div>
			<div className="blue-background absolute-container hero">
				<div className="absolute-container">
					<div className="absolute-overlay">
						<Wprr.Image src={mobileImageUrl} className="image background-cover full-size" />
					</div>
					<div className="position-relative centered-site hero-overlay-text-color">
						<div className="spacing double" />
						<h1 className="hero-overlay-title">
							{Wprr.text(title)}
						</h1>
						<div className="spacing standard" />
						<Wprr.FlexRow>
							<Wprr.Link href="/request-a-quote/" className="custom-styled-link">
								<Wprr.layout.interaction.Button className="standard-button standard-button-hover standard-button-padding cursor-pointer text-align-center" text="Request a quote" />
							</Wprr.Link>
						</Wprr.FlexRow>
						<div className="spacing standard" />
						<div>
							<ElfsightAggregatedRating />
						</div>
						<div className="spacing double" />
					</div>
				</div>
				<div className="usps-banner">
					<div className="spacing small" />
					<div className="usps-banner-centering">
						<div className="flex-row justify-between">
							<div className="flex-row-item font-bold">
								{Wprr.text(Wprr.sourceReference("blockData", "usp1"))}
							</div>
							<div className="flex-row-item font-bold">
								{Wprr.text(Wprr.sourceReference("blockData", "usp2"))}
							</div>
							<div className="flex-row-item font-bold">
								{Wprr.text(Wprr.sourceReference("blockData", "usp3"))}
							</div>
						</div>
					</div>
					<div className="spacing small" />
				</div>
				<div className="position-relative hero-overlay-text-color">
					<div className="spacing small" />
					<div className="centered-site hero-overlay-text-color">
						<Wprr.HasData check={text} checkType="notEmpty">
							<div className="spacing small" />
							<div className="hero-overlay-text">
								{Wprr.text(text, "html")}
							</div>
						</Wprr.HasData>
					</div>
					<div className="spacing double" />
					<Wprr.ContentsAndInjectedComponents content={Wprr.sourceReference("blockData", "innerMarkup")} />
					<div className="spacing double" />
				</div>
			</div>
		</div>;
		

		let desktopLayout = <div>
			<div className="blue-background absolute-container hero">
				<div className="absolute-container">
					<div className="absolute-overlay">
						<svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" className="full-size">
							<defs>
								<clipPath id="diagCrop" clipPathUnits="objectBoundingBox">
								<polygon points="0,0 1,0 1,0.5 0,1" />
								</clipPath>
							</defs>
							<image
								href={image}
								width="100%" height="100%" 
								preserveAspectRatio="xMidYMid slice"
								clip-path="url(#diagCrop)" />
						</svg>
					</div>
					<div className="position-relative centered-site hero-overlay-text-color">
						<div className="spacing double" />
						<div className="spacing double" />
						<h1 className="hero-overlay-title">
							{Wprr.text(title)}
						</h1>
						<div className="spacing standard" />
						<Wprr.FlexRow>
							<Wprr.Link href="/request-a-quote/" className="custom-styled-link">
								<Wprr.layout.interaction.Button className="standard-button standard-button-hover standard-button-padding cursor-pointer text-align-center" text="Request a quote" />
							</Wprr.Link>
						</Wprr.FlexRow>
						<div className="spacing standard" />
						<div>
							<ElfsightAggregatedRating />
						</div>
						<div className="spacing double" />
						<div className="spacing double" />
					</div>
				</div>
			
				<div className="position-relative hero-image-overlap-position hero-overlay-text-color">
					<div className="centered-site">
						<Wprr.FlexRow className="micro-item-spacing" itemClasses="flex-resize,flex-no-resize">
							<div>
								
								<Wprr.HasData check={text} checkType="notEmpty">
									<div className="spacing double" />
									<div className="spacing double" />
									<div className="hero-overlay-text">
										{Wprr.text(text, "html")}
									</div>
								</Wprr.HasData>
								
							</div>
							<div>
								<Wprr.Image src="hero-logo.png" className="image background-contain hero-logo" />
							</div>
						</Wprr.FlexRow>
						
					</div>
					<div className="spacing double" />
					<Wprr.ContentsAndInjectedComponents content={Wprr.sourceReference("blockData", "innerMarkup")} />
					<div className="spacing double" />
				</div>
			</div>
			<div className="usps-banner">
				<div className="spacing small" />
				<div className="usps-banner-centering">
					<div className="flex-row justify-between">
						<div className="flex-row-item font-bold">
							{Wprr.text(Wprr.sourceReference("blockData", "usp1"))}
						</div>
						<div className="flex-row-item font-bold">
							{Wprr.text(Wprr.sourceReference("blockData", "usp2"))}
						</div>
						<div className="flex-row-item font-bold">
							{Wprr.text(Wprr.sourceReference("blockData", "usp3"))}
						</div>
					</div>
				</div>
				<div className="spacing small" />
			</div>
		</div>;

		let responsiveLayout = Wprr.creators.responsiveTemplate(mobileLayout);
		responsiveLayout.addResponsiveTemplate(desktopLayout, 860);

		return <React.Fragment>
			{responsiveLayout.getReactElements()}
		</React.Fragment>;
	}
	
	static getWpAdminEditor() {
		console.log("getWpAdminEditor");
		
		let dataSettings = {
			
		};
		
		return <Wprr.layout.admin.WpBlockEditor dataSettings={dataSettings}>
			<div>
				<Wprr.layout.form.LabelledArea label="Image">
					<Wprr.wp.blocks.editor.ImageSelection valueName="image" />
				</Wprr.layout.form.LabelledArea>
				<Wprr.layout.form.LabelledArea label="Mobile image">
					<Wprr.wp.blocks.editor.ImageSelection valueName="mobileImage" />
				</Wprr.layout.form.LabelledArea>
				<Wprr.layout.form.LabelledArea label="Title">
					<Wprr.FormField value={Wprr.sourceReference("wprr/wpBlockEditor/externalStorage", "title")} />
				</Wprr.layout.form.LabelledArea>
				<Wprr.layout.form.LabelledArea label="Text">
					<Wprr.wp.blocks.editor.RichTextEditor valueName="text" externalStorage={Wprr.sourceReference("wprr/wpBlockEditor/externalStorage")} />
				</Wprr.layout.form.LabelledArea>
				<Wprr.layout.form.LabelledArea label="USP 1">
					<Wprr.FormField value={Wprr.sourceReference("wprr/wpBlockEditor/externalStorage", "usp1")} />
				</Wprr.layout.form.LabelledArea>
				<Wprr.layout.form.LabelledArea label="USP 2">
					<Wprr.FormField value={Wprr.sourceReference("wprr/wpBlockEditor/externalStorage", "usp2")} />
				</Wprr.layout.form.LabelledArea>
				<Wprr.layout.form.LabelledArea label="USP 3">
					<Wprr.FormField value={Wprr.sourceReference("wprr/wpBlockEditor/externalStorage", "usp3")} />
				</Wprr.layout.form.LabelledArea>
			</div>
			{React.createElement(wp.editor.InnerBlocks, null)}
						{React.createElement(Wprr.FlexRow, {className: "small-item-spacing vertically-center-items", itemClasses: "flex-resize,flex-no-resize,flex-resize"},
							React.createElement("hr", {className: "line no-margin"}),
							React.createElement("div", null, Wprr.translateText("End:"), " ", Wprr.translateText("Hero")),
							React.createElement("hr", {className: "line no-margin"})
						)}
		</Wprr.layout.admin.WpBlockEditor>;
	}
}